import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../../services/auth.service';

export const authGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
   const authService = inject(AuthService);
   const router = inject(Router);

   return authService.restoreSession().pipe(
      map((authenticated) =>
         authenticated
            ? true
            : router.createUrlTree(['/login'], {
                 queryParams: { returnUrl: state.url },
              }),
      ),
   );
};
